import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TotalDebts from '../../../images/newDesign/total_debts.svg';
import TotalTenants from '../../../images/newDesign/total_tenants.svg';
import ClarificationPayments from '../../../images/newDesign/for_clarification.svg';
import FailedPayments from '../../../images/newDesign/failed.svg';
import { CurrencyValue } from '../../../common/currencyValue';
import { useAccessToken } from '../../../common/hooks/useAccessToken';
import BllinkUtils from '../../../common/utils/utils';
import { showLoader, hideLoader } from '../../../store/common/slice';
import { StyledGeneralBuildingData } from './GeneralBuildingData.styled';
import NumbersCard from './NumbersCard';
import FinancialData from './FinancialData';

const Strings = BllinkUtils.Strings;

const GeneralBuildingData = ({ buildingID }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();

    const [buildingData, setBuildingData] = useState();

    useEffect(async () => {
        if (!client) return;

        dispatch(showLoader());
        const response = await client.managers.dashboard.getGeneralData(buildingID);
        setBuildingData(response);

        dispatch(hideLoader());
    }, [client]);

    return (
        <StyledGeneralBuildingData>
            <div className='general-data-title'>{t('buildings.general_building_data')}</div>
            <div className='stats-cards-wrapper'>
                <NumbersCard 
                    score
                    percentage={buildingData?.buildingScore}
                />

                <NumbersCard 
                    img={TotalDebts}
                    title={t('reports.total_debts')}
                    amount={<CurrencyValue currency={buildingData?.totalDebts.currency}>{buildingData?.totalDebts.value}</CurrencyValue>}
                    money
                />

                <NumbersCard 
                    img={TotalTenants}
                    title={t('reports.total_tenants')}
                    amount={buildingData?.totalTenantsCount}
                />

                <NumbersCard 
                    img={ClarificationPayments}
                    title={t('reports.for_clarification')}
                    amount={buildingData?.paymentsForClarificationCount}
                    waiting
                />

                <NumbersCard 
                    img={FailedPayments}
                    title={t('reports.failed_transactions')}
                    amount={buildingData?.failedTransactions}
                    failed
                />
            </div>

            <FinancialData buildingID={buildingID} />
        </StyledGeneralBuildingData>
    )
}

export default GeneralBuildingData;